export enum UserClaims {
    SELL= "canSell",
    CHANGE_PRICE= "canChangePrice",
    UNRESERVE_ANY= "canUnreserveAny",
    MANAGE_STAFF= "canManageStaff",
    SEARCH_BY_UNIT_NUMBER= "canSearchByUnitNumber",
    COLLAPSE_PACKAGE= "canCollapsePackage",
    REJECT_ANY_DOC= "canRejectAnyDoc",
    REASSIGN= "canReassign",
    SIGN_AS_DEVELOPER= "canSignAsDeveloper",
    VERIFY_DEAL= "canVerifyDeal",
    CHANGE_DEAL_STATUS= "canChangeDealStatus",
    DO_ADMIN= "canDoAdmin",
    PRIVILEGE_ADMIN= 'canDoPrivilegeAdmin',
    EXECUTIVE_REPORT= 'canDownloadExecutiveReport',
    OFFPLAN_ACCESS= 'isMPEnabled',
    MARKETING= 'canDoMarketing'
}
